
export default "/assets/format-quote.c9b06985.svg"